import React from 'react'
import PropTypes from 'prop-types'
import { Link as _Link } from '@morningtrain/react-navigation'

function Link (props) {
  const classNames = [
    'text-' + props.size,
    'font-medium',
    'text-primary-500',
    'hover:text-primary-400',
    'focus:outline-none',
    'focus:underline',
    'transition',
    'ease-in-out',
    'duration-150'
  ]

  return (
    <_Link {...props} className={classNames.join(' ')}>
      {props.children}
    </_Link>
  )
}

Link.defaultProps = {
  href: null,
  size: 'base'
}

Link.propTypes = {
  /**
     * Button label
     */
  label: PropTypes.string.isRequired,
  /**
     * Link HREF attribute
     */
  href: PropTypes.string,
  /**
     * Link font size<br>
     * Options: 'base', 'sm', 'xs'
     * Default: 'base'
     */
  size: PropTypes.string
}

export default Link
